import 'bootstrap/dist/css/bootstrap.min.css'
import {useState} from "react";
function Login() {

    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');

    const handleUserName = (e) => {
        setUsername(e.target.value);
    }

    const handlePassword = (e) => {
        setPassword(e.target.value);
    }

    const handleLogin = (e) => {
        e.preventDefault();
        // fetch api then set cookie from response
        fetch("https://iot-temphumid.herokuapp.com/login", {
            method: 'POST',
            credentials: 'include',
            headers: { 'Content-Type': "application/json" },
            body: JSON.stringify({ username: username, password: password }),
               })
            .then(res => res.json())
            .then(res => {
                if (res.message === 'Authenticated') {
                    //set local storage for a day
                    sessionStorage.setItem('isLoggedIn', true);
                    window.location.href = "/";
                } else {
                    alert("Invalid username or password");
                }
            })


    }

    return (
        <div className="container mt-5">
            <div className="row">
                <div className="col-md-6 mx-auto">
                    <div className="card">
                        <div className="card-header">
                            <h4>Login</h4>
                        </div>
                        <div className="card-body">
                            <form>
                                <div className="form-group">
                                    <label form="username">Username</label>
                                    <input onChange={handleUserName} type="text" className="form-control" id="username" placeholder="Enter username" value={username} />
                                </div>
                                <div className="form-group">
                                    <label form="password">Password</label>
                                    <input onChange={handlePassword} type="password" className="form-control" id="password" placeholder="Enter password" value={password} />
                                </div>
                                <button type="submit" onClick={handleLogin} className="btn btn-primary btn-block mt-2">Submit</button>
                                <p className="text-center h6">Don't have an account? <a href="/register">Register</a></p>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Login;